import script from "./EditorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorPage.vue?vue&type=script&setup=true&lang=js"

import "./EditorPage.vue?vue&type=style&index=0&id=8d0b716e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d0b716e"]])

export default __exports__